import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import '@shui/core/sh-notifications';

export interface NotificationOptions {
    type: 'success' | 'error' | 'warning';
    title: string;
    description: string;
    duration?: number;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private readonly document = inject(DOCUMENT);
    private container: HTMLElement | null = null;

    public show(options: NotificationOptions): void {
        const container = this.getOrCreateContainer();
        const item = this.document.createElement('sh-notification-item');

        item.setAttribute('label', options.title);
        item.setAttribute('type', options.type);
        item.setAttribute('duration', `${options.duration ?? 10000}ms`);
        item.textContent = options.description;

        item.addEventListener('close', () => {
            item.remove();
        });

        container.appendChild(item);
        item.setAttribute('visible', '');
    }

    private getOrCreateContainer(): HTMLElement {
        if (this.container && this.document.body.contains(this.container)) {
            return this.container;
        }

        let container = this.document.querySelector('sh-notifications');
        if (!container) {
            container = this.document.createElement('sh-notifications');
            container.setAttribute('position', 'bottom-center');
            this.document.body.appendChild(container);
        }

        this.container = container as HTMLElement;
        return this.container;
    }
}
